export const SUBZERO_BRAND_NAME = 'Sub-Zero Refrigeration';
export const SUBZERO_API_NAME = 'Subzero_Refrigeration';
export const SUBZERO_SLUG = 'subzero-refrigeration';
export const WOLF_BRAND_NAME = 'Wolf Cooking';
export const WOLF_SLUG = 'wolf-cooking';
export const WOLF_API_NAME = 'Wolf_Cooking';
